import React from "react";
import MasonryList from "./MuiMasonryList.jsx";
import * as Utils from "../utils/Utils.js";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@material-ui/core/IconButton";
import { hideIntercom, showIntercom} from "../utils/Utils.js";

export default class BasicModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
      items: this.props.items,
    };

    this.openModal = () => {
      this.setState({
        open: true,
      });
        hideIntercom();
        document.documentElement.style.overflow = "hidden";
    };

    this.closeModal = () => {
      this.setState({
        open: false,
      });
      showIntercom();
      document.documentElement.style.overflow = "auto";
    };
  }
  handleOpen = () => this.openModal();
  handleClose = () => this.closeModal();

  componentDidUpdate(prevProps, prevState) {
    if (this.props.items !== prevProps.items) {
      this.setState({
        items: this.props.items,
      });
    }
  }

  render() {
    return (
      <div>
        <span className="masonryOpen" onClick={this.openModal}>
          {playdetailsv2_resources.viewAll}
        </span>
        <Dialog
          fullScreen={true}
          open={this.state.open}
          onClose={this.closeModal}
          aria-labelledby="Gallery"
          aria-describedby="image and video gallery"
        >
          <DialogTitle className="r_galleryTitle">
            <div className="r_dialogTitle">
              <div className="r_dialogTitleText">
                {playdetailsv2_resources.Gallery}
              </div>
              <IconButton
                style={{ backgroundColor: "transparent" }}
                onClick={this.closeModal}
                id="r_closeMasonry"
              >
                <CloseIcon className="r_dialogTitleIcon" />
              </IconButton>
            </div>
          </DialogTitle>
          <DialogContent>
            <MasonryList itemData={this.state.items} />
          </DialogContent>
        </Dialog>
      </div>
    );
  }
}
